<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <b>Agendamentos</b>
            </h3>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-md-3">
                <input
                  v-validate="'required'"
                  type="month"
                  class="form-control"
                  v-model="dados.data"
                />
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <v-select
                    placeholder="Operador"
                    v-model="dados.operadorSelecionado"
                    :options="operadores"
                  ></v-select>
                </div>
              </div>
              <div class="col-md-4">
                <input
                  style="width: 100%"
                  class="form-control"
                  placeholder="Busca: Entre com o NOME ou DOCUMENTO do cliente e pressione enter"
                  name="filtro_pesquisa"
                  ref="filtro_pesquisa"
                  type="text"
                  v-model="dados.pesquisa"
                  @keyup.enter="getDataTable"
                />
              </div>
              <div class="col-md-2">
                <button @click="getDataTable" class="btn btn-default btn-block">
                  <i class="fa fa-filter"></i> Filtrar
                </button>
              </div>
            </div>
            <div class="row" style="margin-top:15px">
              <div class="col-sm-12 table-responsive">
                <table
                  aria-describedby="example1_info"
                  role="grid"
                  id="example1"
                  class="table table-bordered table-striped"
                >
                  <thead>
                    <tr role="row">
                      <th style="width:auto">Data</th>
                      <th style="width:auto">Descrição</th>
                      <th style="width:auto">Pessoa</th>
                      <th style="width:auto">Cpf/Cnpj</th>
                      <th style="width:auto">Log</th>
                      <th style="width:auto">Status</th>
                      <th style="width:auto">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="even" role="row" v-for="item in apiData.data" :key="item.id">
                      <td>{{ item.data | dataFormatada }}</td>
                      <td>{{ item.descricao }}</td>
                      <td>{{ item.pessoa.nome_razao }}</td>
                      <td>{{ item.pessoa.cpf_cnpj }}</td>
                      <td>Registrado em:
                        <b>{{ item.created_at | dataHoraFormatada }}</b> por
                        <b>{{ item.usuario.name }}</b></td>
                      <td>{{ item.status }}</td>
                      <td>
                        <button class="btn btn-primary" @click="statusFeito()">
                          <i class="fa fa-fw fa-check"></i>
                        </button>
                        <button class="btn btn-primary" @click="modalAgendamentosOpen(item.pessoa.id)">
                          <i class="fa fa-fw fa-list"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="row">
                  <div
                    class="col-sm-5"
                  >Mostrando {{ this.apiData.from }} até {{ this.apiData.to }} de {{ this.apiData.total }} registros encontrados.</div>
                  <div class="col-sm-7" style="text-align:right">
                    <laravue-pagination
                      :limit="5"
                      :data="apiData"
                      v-on:pagination-change-page="getDataTable"
                    >
                      <span slot="prev-nav">&lt; Anterior</span>
                      <span slot="next-nav">Próximo &gt;</span>
                    </laravue-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
        <!-- /.box -->
      </div>
      <!-- /.col-md-12 -->
    </div>
    <!-- /.row -->

    <transition v-if="showModalAgendamentos" name="modal">
      <div class="modal-mask">
        <div class="modal-container">
          <div class="modal-header">
            <h3>Agendamentos dessa pessoa</h3>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                <inadimplente-agendamento :pessoaId="pessoaId"></inadimplente-agendamento>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="text-right" style="float:right">
              <button
                class="btn btn-default"
                @click="modalAgendamentosClose()"
              >
                <i class="fa fa-close"></i> Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http
import vSelect from "vue-select";
import InadimplenteAgendamento from "../inadimplentes/inadimplenteAgendamento";

export default {
  components: {
    InadimplenteAgendamento,
    vSelect,
  },
  data: () => ({
    showModalAgendamentos: false,
    pessoaId: null,
    dados: {
      pesquisa: "",
      data: "",
      operadorSelecionado: null,
    },
    operadores: [],
    apiData: {},
  }),
  mounted() {
    this.getDataTable();
    // this.getOperadores();
    this.$nextTick(() => {
      this.$refs.filtro_pesquisa.focus();
    });
  },

  methods: {
    statusFeito() {
      this.$swal({
        title: "Marcar como feito!",
        text: "Confirma agendamento feito?",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
        cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          console.log("status feito");
        }
      })
    },
    modalAgendamentosOpen(id) {
      this.pessoaId = id;
      this.showModalAgendamentos = true
    },
    modalAgendamentosClose() {
      this.pessoaId = null;
      this.showModalAgendamentos = false
    },
    getOperadores() {
      axios
        .get(
          `${this.$store.state.serverURI}/api/empresa/dataForSelect`,
          this.$store.getters.getHeaderAuth
        )
        .then((response) => {
          this.operadores = response.data;
        });
    },
    getDataTable(page) {
      if (typeof page === "undefined") {
        page = 1;
      }
      this.dados.page = page;
      let config = this.$store.getters.getHeaderAuth;
      config.params = this.dados;
      axios
        .get(
          `${this.$store.state.serverURI}/api/pessoa/getAllNotesPaginate`,
          config
        )
        .then((response) => {
          console.log(response);
          this.apiData = response.data;
        })
        .catch((error) => {
          this.$store.commit("throwException", error);
        });
    },
  },
  watch: {
    page: function (val) {
      this.getDataTable();
    },
  },

};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// agendamentos.vue?92ed2e76